import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { WITHOUT_SYSTEM, WITH_SYSTEM } from '../data/content';
export function Comparison() {
  return <section aria-labelledby="comparison-title" className="w-full bg-soft px-3 py-6 sm:px-5" data-id="element-48" data-mp="1g8krbmrsm4nb">
      <div className="mx-auto max-w-3xl" data-id="element-49" data-mp="1l630ne9q2lvu">
        <h2 id="comparison-title" className="text-center font-head text-xl uppercase leading-[0.98] text-navy sm:text-3xl" data-id="element-50" data-mp="1pxujf2mmznbf">
          Keep searching for the next resource...
          <span className="mt-0.5 block text-green" data-id="element-51" data-mp="1uzjrc9ekbkva">Or have the system ready.</span>
        </h2>

        <div className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-52" data-mp="1zy4uagl78inf">
          <div className="rounded-xl border border-coral/30 bg-white p-3" data-id="element-53" data-mp="23z6x17ebrcu5">
            <h3 className="font-head text-sm uppercase tracking-wide text-coral sm:text-base" data-id="element-54" data-mp="28xi2l5xl716k">
              Without Kids Learning Ready™
            </h3>
            <ul className="mt-1.5 space-y-0.5" data-id="element-55" data-mp="9lyyp5r54j3r">
              {WITHOUT_SYSTEM.map(item => <li key={item} className="flex items-start gap-1.5 text-[12px] leading-snug text-navy sm:text-[13px]" data-id="element-56" data-mp="ejh78v18wwb8">
                  <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-coral" aria-hidden="true" data-id="element-57" data-mp="1m2trbp4b40ul" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-xl border border-green/30 bg-white p-3" data-id="element-58" data-mp="1d96udvod4rjt">
            <h3 className="font-head text-sm uppercase tracking-wide text-green-dark sm:text-base" data-id="element-59" data-mp="18a3sul7ld3gl">
              With Kids Learning Ready™
            </h3>
            <ul className="mt-1.5 space-y-0.5" data-id="element-60" data-mp="24x8od9725jfs">
              {WITH_SYSTEM.map(item => <li key={item} className="flex items-start gap-1.5 text-[12px] leading-snug text-navy sm:text-[13px]" data-id="element-61" data-mp="20yht77m5kbvb">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-green" aria-hidden="true" data-id="element-62" data-mp="1w0pyy6y1cdny" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}